module.exports = __webpack_public_path__ + "img/planb_mp.147808f5.png";